import { render, staticRenderFns } from "./IconHomeworkMono.vue?vue&type=template&id=fa631f9c&scoped=true"
import script from "./IconHomeworkMono.vue?vue&type=script&lang=js"
export * from "./IconHomeworkMono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa631f9c",
  null
  
)

export default component.exports